import { stories } from './cardData';

export const sharpScribe = {
  currentStoryId: '3',
  stories: stories.filter((story) => story.id !== '3'),

  heroContent: {
    title: 'SharpScribe Brings AI to the Doctor’s Office',
    description:
      'Healthcare providers face growing documentation demands, often spending valuable time manually entering notes into Electronic Medical Record (EMR) systems like EPIC. SharpScribe set out to solve this challenge by creating a solution that empowers physicians to record patient encounters, automatically transcribe conversations into structured clinical notes, and seamlessly sync those notes into the EMR platform — all while ensuring HIPAA compliance and supporting better patient care. To bring this vision to life, SharpScribe partnered with DIGU.',
    buttonText: 'More about SharpScribe',
    buttonLink: 'https://sharpscribe.com/',
    image: require(`@/assets/img/sharpscribe.svg`),
    navIndicator: [
      { text: 'Home', icon: 'fas fa-home', link: '/' },
      { text: 'Customer Stories', link: '/customers' },
      { text: 'SharpScribe Brings AI to the Doctor’s Office', link: '' },
    ],
  },
  tocSections: [
    { title: 'Key Stats', link: '#key-stats' },
    { title: 'The Challenge', link: '#the-challenge' },
    {
      title: 'The Solution: DIGU’s Staff Augmentation Service',
      link: '#the-solution',
    },
    { title: 'The Results', link: '#the-results' },
    {
      title: 'Impact Beyond Business: Empowering Nepal’s Tech Ecosystem',
      link: '#impact',
    },
    // { title: 'More Stories', link: '#more-stories' },
  ],
  keyMetrics: [
    { label: 'Service', value: 'Build My App', color: '#FFD1D1' },
    {
      label: 'Service Type',
      value: 'Software Engineering Service',
      color: '#D1E5FF',
    },
    { label: 'Project Kickoff Time', value: '1 week', color: '#D1E5FF' },
    { label: 'Project Duration', value: '2.5 months', color: '#D1E5FF' },
  ],
  challengeContent: {
    title: 'The Challenge',
    description: [
      'SharpScribe wanted to build a Minimum Viable Product (MVP) that could:',
    ],
    roadblocks: [
      ':Allow physicians to record patient sessions easily.',
      ':Transcribe audio recordings into structured clinical notes.',
      ':Seamlessly integrate these notes into EPIC, one of the most widely used Electronic Medical Record (EMR) systems.',
      ':Ensure HIPAA compliance and maintain the highest standards of security.',
    ],
    endparagraphs: [
      'However, building a solution that combined real-time AI transcription with complex EMR integrations proved to be highly challenging. SharpScribe needed more than just software developers—they needed a team that could move fast, understand the healthcare landscape, and adapt to rapid iterations based on physician feedback.',
      'With a strong vision for their product and a clear understanding of market needs, SharpScribe sought a development partner who could complement their internal capabilities, accelerate time-to-market, and bring deep expertise in both AI and healthcare integrations. They needed a team that could move quickly, adapt to user feedback, and navigate the technical demands of building a secure, scalable MVP. That’s when they partnered with DIGU.',
    ],
    showEndparagraphs: true,
    quoteBackgroundColor: '#f0f4ff',
    order: 3,
    showQuote: false,
    showQuoteAuthor: false,
  },
  solutionContent: {
    title: 'The Solution',
    description: [
      'DIGU partnered with SharpScribe to bring their vision to life. We helped design, build, and deliver the MVP that:',
    ],
    benefits: [
      'Enabled AI-Powered Transcription: Developed a seamless experience for physicians to capture patient interactions and turn them into clinical notes using advanced AI.',
      'Integrated with EPIC Systems: Achieved secure and reliable integration with EPIC EMR, enabling automatic, real-time syncing of notes into patient records.',
      'Delivered Rapidly: Accelerated MVP delivery, helping SharpScribe move quickly to customer testing and feedback stages.',
      'Maintained Highest Compliance Standards: Ensured HIPAA compliance and data security throughout the process.',
    ],
    conclusion:
      'Today, SharpScribe’s MVP is live with customer testing underway, setting the foundation for scaling their offering across healthcare organizations.',
    showBenefitTitle: true,
  },
  resultsContent: {
    title: 'The Results',
    description:
      'Partnering with DIGU enabled SharpScribe to accelerate product development while maintaining the highest standards in security, usability, and integration. Today, SharpScribe has:',
    outcomes: [
      ':A fully functional MVP actively being tested by physicians in real clinical settings',
      ':A robust, secure integration with the EPIC EMR system',
      ':A faster, feedback-driven path to product refinement and scale',
      ':A long-term technology partner in DIGU, supporting ongoing innovation',
    ],
    subtitle: 'Measurable Outcomes',
    measureableOutcomes: [
      'Accelerated Time-to-Market: Delivered the MVP 40% faster than industry averages, helping SharpScribe move swiftly toward pilot testing and user validation',
      'AI Integration Efficiency: Leveraged DIGU’s expertise to improve AI integration by 20%, enhancing transcription accuracy and performance',
      'Seamless EMR Connectivity: Achieved an 85% success rate in AI-to-EMR integration, aligning with healthcare interoperability standards',
      'Significant Cost Savings: Reduced development costs by up to 70% compared to typical U.S. market rates for similar services',
      'Scalable Engineering Support: Enabled flexible access to high-quality engineering talent, removing bottlenecks and supporting future growth',
      'Quality and Innovation Commitment: Reflected in a near 100% client satisfaction rate, driven by DIGU’s focus on continuous improvement and delivery excellence',
      'Cultural & Communication Alignment: Maintained an 80% satisfaction rate in cross-cultural collaboration, ensuring smooth day-to-day execution and alignment',
    ],
    watermarkText: 'DIVACS',
    divacsColor: '#2196f3',
    showDescription: true,
  },
  impactContent: {
    title: 'Impact Beyond Business: Empowering Nepal’s Tech Ecosystem',
    description:
      'DIGU is one of the most trusted and reliable professional IT service firms, delivering scalable, cost-effective solutions for SaaS startups and enterprises. However, our impact extends beyond business. Through the DIGU Grassroots Impact Initiative, every hire and project drives real change in Nepal’s tech community. ',
    meterDescription:
      'Our Impact Meter provides clear insights into the measurable difference that DIVACS and DIGU have created in the Nepalese community.',
    categories: [
      {
        title: 'Job Creation',
        metrics: [{ label: 'Professionals Hired by DIGU', value: 1 }],
      },
      {
        title: 'Overall Grassroot Impact',
        highlightHeader: true,
        metrics: [
          { label: 'Families Supported', value: 1 },
          { label: 'Skilled Professionals Retained in Nepal', value: 1 },
        ],
      },
    ],
    showMeterDescription: false,
  },
};
